"use strict";

export default function round(x, prec) {
	prec = prec !== undefined && prec !== null ? prec : 1;
	var factor = Math.pow(10, prec);
	return Math.round(x*factor)/factor;
}


// WEBPACK FOOTER //
// ./~/vwa/utils/round.js